import React, { useContext } from 'react'

import { getTestParam } from '@js/common/utils'

import { QuizContext } from '@f/applications/QuizApp/context/QuizContext'
import QuestionHeading from '@f/applications/QuizApp/partials/QuestionHeading'
import LocationFinderBVer from '@f/components/LocationFinder'
import LocationFinderBackup from '@f/components/LocationFinder/LocationFinderBackup'
import Icon from '@f/elements/Icon'
const isBVersionTest = getTestParam('NR-10472_maps_api_v2') === 'B'
const LocationFinder = isBVersionTest
  ? LocationFinderBVer
  : LocationFinderBackup

const QuestionDeliveryRegion = ({ step }) => {
  const context = useContext(QuizContext)

  const handleLocationChange = location => {
    context.actions.updateValues({
      stepID: step.id,
      valuesToSave: [
        {
          name: step.values[0].name,
          value: location.postcode
        }
      ]
    })
  }

  return (
    <>
      <QuestionHeading heading={step.heading} subheading={step.subheading} />
      <div className='[ f-wrap ]'>
        <div className='[ f-m-h-auto f-radius-card-large f-shadow-strong f-m-t-030 f-c-ba-whi ] QuizApp-long-card'>
          <div
            className='[ f-m-h-auto f-d-flr f-fl-al-ce f-p-v-030 f-p-h-020 ]'
            style={{ maxWidth: '300px', height: '134px' }}>
            <div className='[ f-m-r-020 ]'>
              <Icon
                icon={step.options[0].icon}
                className='[ f-icon-080 f-c-st-pri ]'
              />
            </div>
            <div className='[ f-fl-expand ]'>
              <div className='[ f-m-b-010 f-t-body f-c-fo-neu200 ]'>
                PLZ oder Ort
              </div>
              <LocationFinder
                placeholder='z.B. 10178 Berlin'
                onChange={handleLocationChange}
                className='[ f-d-inbl ]'
              />
            </div>
          </div>
          <div className='[ f-c-ba-bac015 f-t-body f-p-a-020 f-c-fo-neu200 f-t-centre f-t-bold f-radius-card-large-bottom ] QuizApp-long-card-label'>
            {step.options[0].label}
          </div>
        </div>
      </div>
    </>
  )
}

export default QuestionDeliveryRegion
